import { SalesOrdersShell } from './sales-orders/SalesOrdersShell';

/**
 * Sales Orders dashboard — own-component, NOT a ScheduledShell wrapper.
 *
 * Pulls its own data from ``analytics/sales-orders-dashboard/`` which pivots
 * on ``purchasing_purchase_order_line.delivery_date`` and joins
 * ``purchasing_purchase_order`` directly. NO joins to po_line_schedule.
 *
 * Sections: Order Status (Open / On Hold counts) · Delivery (OTIF/OTD)
 * · Cost (Open Order Lines / Received / Arrears). NO Quality. NO Forecast tab.
 */
export function SalesOrdersTab() {
  return <SalesOrdersShell />;
}
